
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// module components
import PretensionFiles from '@/modules/PretensionsModule/components/PretensionFiles/index.vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// composable
import { useRoute } from 'vue-router'

// types
import { LeadFull } from '@/core/types/preferences.types'

// @new-services
import { preferences } from '@/core/realisations/preferences.realisation'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        FailedFetch,
        Loader,
        Cheap,
        PretensionFiles,
    },
    setup() {
        const route = useRoute()
        const id = Number(route.params.id)

        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            lead: null as LeadFull | null,
        })

        const loadLead = async () => {
            try {
                state.is_loading = true

                const response = await preferences.getLead(id)
                state.lead = response.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadLead)

        return {
            state,
            loadLead,
        }
    },
})
